/*
 * Original Copyright GitHub, Inc. Licensed under the MIT License.
 * See license text at https://github.com/github/markdown-toolbar-element/blob/master/LICENSE.
 */

export interface SelectionRange {
  text: string;
  selectionStart: number | undefined;
  selectionEnd: number | undefined;
}

let canInsertText: boolean | null = null;

export default function insertText(textarea: HTMLDivElement, { text, selectionStart, selectionEnd }: SelectionRange) {
  const selection = window.getSelection();

  const range = selection.getRangeAt(0); // 获取当前选区范围
  // range.selectNodeContents(textarea)
  let startNode = range.startContainer
  let startIndex = range.startOffset;
  let endIndex = range.endOffset;
  let selectionstart = selectionStart;
  let selectionend = selectionEnd;

  if (textarea.innerHTML.indexOf('<img') !== -1 && textarea.innerHTML.indexOf('<img') < textarea.innerHTML.indexOf(selection.toString())) {
    startIndex = range.startOffset + textarea.innerHTML.slice(0, textarea.innerHTML.indexOf('>')).length + 1;
    endIndex = range.endOffset + textarea.innerHTML.slice(0, textarea.innerHTML.indexOf('>')).length + 1;
    // selectionstart += textarea.innerHTML.slice(0, textarea.innerHTML.indexOf('>')).length + 1;
    // selectionend += textarea.innerHTML.slice(0, textarea.innerHTML.indexOf('>')).length + 1;
  }

  const originalSelectionStart = startIndex;
  let before = textarea.innerHTML.slice(0, originalSelectionStart);
  let after = textarea.innerHTML.slice(endIndex);
  if (text.includes('[upl-image-preview')) {
    before = textarea.innerHTML.slice(0, selectionstart);
    after = textarea.innerHTML.slice(selectionend);
  }


  // const editableDiv = document.getElementById('myTextarea')
  let textVal;
  if (canInsertText === null || canInsertText === true) {
    try {
      if (text.includes('[upl-image-preview')) {
        // const urlParamsRegex = /src=\[[^\]]*url=(https?:\/\/[^\]]+)\]/;
        // const urlMatch = urlParamsRegex.exec(text);
        const urlSplit = text.split('url=');
        const url = urlSplit[1].split(']');
        if (url) {
          const actualImageUrl = '[upl-image-preview' + url[0] + ']';
          // const div = document.createElement('img');
          // div.src = actualImageUrl;
          // editableDiv.appendChild(div);
          let currentHtml = textarea.innerHTML;
          let updatedHtml = currentHtml.slice(0, selectionstart) + actualImageUrl + currentHtml.slice(selectionend);
          textarea.innerHTML = updatedHtml;
        }

        // 创建一个新的 div 元素
        // 将包含图片标签的字符串赋值给这个 div 元素的 innerHTML 属性
        // div.innerHTML = text;

        // 将新创建的带有图片标签的 div 元素添加到页面的特定容器中
        canInsertText = true;
      } else {

        // canInsertText = document.execCommand('insertText', false, text);
      }
    } catch (error) {
      canInsertText = false;
    }
  }

  if (canInsertText && !textarea.innerHTML.slice(0, selectionstart).endsWith(text)) {
    canInsertText = false;
  }

  if (!canInsertText) {
    if (text.includes('[upl-image-preview')) {
      const urlSplit = text.split('url=');
      const url = urlSplit[1].split(']');
      if (url) {
        const actualImageUrl = '<img src=' + url[0] + ' />';

        // const div = document.createElement('img');
        // div.src = actualImageUrl;
        // editableDiv.appendChild(div);
        // editableDiv.innerHTML = actualImageUrl
        textVal = actualImageUrl;
      }
      // 创建一个新的 div 元素
      // const div = document.createElement('div');
      // 将包含图片标签的字符串赋值给这个 div 元素的 innerHTML 属性
      // div.innerHTML = text;

      // 将新创建的带有图片标签的 div 元素添加到页面的特定容器中
      // document.getElementById('myTextarea').appendChild(div);
      canInsertText = true;
    }
    if (textVal === undefined) {

      textarea.innerHTML = before + text + after;
    } else {
      textarea.innerHTML = before + textVal + after;
    }
    textarea.dispatchEvent(new CustomEvent('input', { bubbles: true, cancelable: true }));
    textarea.focus();
  }

  if (selectionstart != null && selectionend != null) {
    // textarea.setSelectionRange(selectionStart, selectionEnd);
    setSelectionRangeInDiv(textarea, selectionstart, selectionend);
  } else {
    setSelectionRangeInDiv(textarea, originalSelectionStart, endIndex);
    // textarea.setSelectionRange(originalSelectionStart, textarea.selectionEnd);
  }
}
function setSelectionRangeInDiv(div: HTMLDivElement, startOffset: number, endOffset: number) {
  // // 创建一个Range对象
  // const range = document.createRange();

  // // 获取div的第一个孩子元素
  // const firstChild = div.firstChild as Node;

  // // 设置Range的边界
  // range.setStart(firstChild, startOffset);
  // range.setEnd(firstChild, endOffset);

  // // 清除现有的选区
  // const selection = window.getSelection();
  // selection.removeAllRanges();

  // // 添加新的选区
  // selection.addRange(range);
  // console.log("selection",selection);

  // // 将焦点设置到div上，确保选区可见
  // div.focus();
  if (!div.contentEditable) {
    console.error('The div should have contenteditable attribute set to true');
    return;
  }

  // 获取div的所有子节点（假设最后一个子节点包含最终文本）
  const lastChild = div.lastChild as Text | null;

  if (lastChild && lastChild.nodeType === Node.TEXT_NODE) {
    // 创建一个Range对象
    const range = document.createRange();

    // 设置Range的边界，使其位于文本节点的末尾
    range.selectNodeContents(lastChild);
    range.collapse(false); // 参数false表示将光标置于范围的结束位置，即内容末尾

    // 清除现有的选区
    const selection = window.getSelection();
    selection.removeAllRanges();

    // 添加新的选区
    selection.addRange(range);

    // 将焦点设置到div上，确保选区可见
    div.focus();
  }
}
